import Model from '@ember-data/model';

import { attr } from '@ember-data/model';

export default class NodeModel extends Model {
  @attr('string') bodyFormat;
  @attr('html') bodyProcessed;
  @attr('string') bodySummary;
  @attr('string') bodyValue;
  @attr('date') createdDate;
}
